import React from "react";
import { Helmet } from "react-helmet";
import Foto1 from "../img/foto 1 exalcalde noe villavicencio detenido.jpg";
import Foto2 from "../img/Foto 2_Mercado Las Américas_Foto Milagros Portilla.jpg";
import Foto3 from "../img/foto 3_parque micaela bastidas_foto Milagros Portilla.jpg";
import Fondo from "../img/Ilustración de portada_Apurimac_edited.jpg";
import SocialShare from "../components/SocialShare";
import { Fade } from "react-awesome-reveal";
import Author from "../img/milagros.jpeg";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";

const NotaApurimac = () => {
  return (
    <>
      <Navbar />
      <div className="nota">
        <Helmet>
          <meta charSet="utf-8" />
          <title>
            Deuda y corrupción como herencia en el municipio de Abancay
          </title>
          <meta
            property="og:title"
            content="Deuda y corrupción como herencia en el municipio de Abancay"
          />
          <meta
            name="description"
            content="Una lista de 25 investigados bajo sospecha de corrupción y una millonaria deuda por el mal llamado “adelanto de canon” son el legado que aún perdura de la gestión edil del periodo 2011-2014"
          ></meta>
          <meta
            property="og:url"
            content={
              process.env.REACT_APP_URL +
              "/deuda-corrupcion-como-herencia-municipio-abancay"
            }
          />
          <meta property="og:image" content={"https://fundacionmohme.org"+Fondo} />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:image:src" content={"https://fundacionmohme.org"+Fondo} />
        </Helmet>
        <div>
          <header className="">
            <div className="header-bg">
              <img
                className="img-fluid"
                src={Fondo}
                alt="Deuda y corrupción como herencia en el municipio de Abancay"
              />
            </div>
            <div className="nota-header-content  ">
              <div className="container d-flex justify-content-center flex-column">
                <Fade delay={80} triggerOnce>
                  <h1>
                    Deuda y corrupción como herencia en el municipio de Abancay
                  </h1>
                  <SocialShare
                    url={
                      process.env.REACT_APP_URL +
                      "/deuda-corrupcion-como-herencia-municipio-abancay"
                    }
                    text="Deuda y corrupción como herencia en el municipio de Abancay"
                  />
                  <p className="bajada d-none d-lg-block d-md-none">
                    Una lista de 25 investigados bajo sospecha de corrupción y
                    una millonaria deuda por el mal llamado “adelanto de canon”
                    son el legado que aún perdura de la gestión edil del periodo
                    2011-2014.
                  </p>
                </Fade>
              </div>
            </div>
          </header>
        </div>
        <main>
          <div className="container">
            <Fade delay={80}>
              <p className="bajada d-none d-block d-lg-none">
                Una lista de 25 investigados bajo sospecha de corrupción y una
                millonaria deuda por el mal llamado “adelanto de canon” son el
                legado que aún perdura de la gestión edil del periodo 2011-2014.
              </p>
            </Fade>
          </div>
          <div className="container">
            <Fade delay={80}>
              <div className="author d-flex">
                <div className="circle">
                  <img
                    src={Author}
                    className="img-fluid"
                    alt="Milagros Portilla"
                  />
                </div>
                Por Milagros Portilla - La República - Apurímac
              </div>
            </Fade>
            <Fade delay={80}>
              <p>
                <span className="capital-letter">E</span>ntre los años 2011 y
                2014, la municipalidad provincial de Abancay gestionó
                millonarios fondos adicionales por un concepto denominado
                “adelanto de canon”. El gobierno central transfirió más de 70
                millones a la comuna, para la ejecución de once obras. Han
                pasado seis años desde que culminó aquella gestión y lo único
                que queda como herencia ahora son diez obras con serios indicios
                de corrupción y una investigación fiscal declarada compleja.
                Hasta el momento son 25 los presuntos implicados.
              </p>
              <p>
                Esta historia nos remonta al 2012. Había transcurrido un poco
                más de un año de iniciada la gestión del entonces alcalde de
                Abancay, Noe Villavicencio Ampuero, quien llegó al cargo con el
                movimiento regional Poder Popular Andino. Esta organización
                estaba liderada por Elías Segovia Ruiz, quien también se hizo
                del sillón del Gobierno Regional de Apurímac.
              </p>

              <p>
                La demanda de la ciudadanía por la ejecución de más obras llevó
                a estas autoridades a pedir más recursos al gobierno nacional.
                Así, el 01 de octubre del 2012, el alcalde Noe Villavicencio
                Ampuero envió el oficio N° 498-2012 al Ministerio de Economía y
                Finanzas (MEF). ¿Qué solicitaba? Más recursos. Ante la opinión
                pública, esta transferencia fue presentada como un “adelanto del
                canon”, pero, en realidad, se trataba de un préstamo. Y con
                intereses.
              </p>
              <p>
                Tres meses después, el 22 de diciembre, el gobierno de Ollanta
                Humala atendió el pedido. Así, mediante el decreto supremo N°
                287-2012-EF, se autorizó transferir al municipio de Abancay la
                suma de S/79 156 012, para la ejecución de once proyectos u
                obras.
              </p>
              <div className="quote bg-grey">
                <em>
                  “Mediante decreto supremo 287-2012-EF, se autorizó transferir
                  al municipio de Abancay la suma de S/79 156 012”
                </em>
              </div>
              <p>
                Al mes siguiente, en enero del 2013, se realizaba la suscripción
                del contrato de crédito entre el MEF, el Banco de la Nación y la
                Municipalidad Provincial de Abancay. El gobierno local se
                obligaba a pagar este crédito hasta el 12 de agosto del 2031.
                ¿Cuánto tenía que devolver el municipio? S/103 545 268.
              </p>
              <p>
                Abancay no fue la única provincia que accedió a esta
                transferencia. También lo hicieron las municipalidades
                provinciales de Grau (S/90 476 012), Cotabambas (S/47 380 341) y
                Andahuaylas (S/66 148 157).
              </p>
              <p>
                Estos presupuestos iban a ser distribuidos de la siguiente
                manera: 34% para infraestructura productiva y saneamiento
                básico, 29% para infraestructura vial, 27% para obras
                educativas, 6% para servicios municipales y 4% para salud, según
                un informe del Colegio de Ingenieros de Apurímac.
              </p>
              <p>
                La prosperidad parecía llegar para la ciudadanía de Apurímac. El
                desarrollo se avizoraba para Abancay. No fue así.
              </p>
              <h2>Sospechas que fueron creciendo</h2>
              <p>
                Los desembolsos se hicieron el 2013. Desde entonces mucha agua
                turbia ha pasado por debajo del puente en Abancay. De hecho,
                desde que se empezó a hablar de la posibilidad de un
                endeudamiento interno o mal llamado “adelanto del canon”, varios
                profesionales advirtieron de la no conveniencia del préstamo,
                pero el alcalde Noé Villavicencio Ampuero hizo oídos sordos.
              </p>

              <p>
                Lo mismo hizo la gestión regional y los demás alcaldes
                provinciales. Hubo, en total, 83 proyectos en curso en toda la
                región, con una partida de S/432 545 776. En el caso específico
                de Abancay, los 11 proyectos en su mayoría tenían que ver con la
                construcción de plazas y parques, además de establecimientos de
                salud y centros de abastos.
              </p>
            </Fade>
            <Fade delay={80}>
              <div className="container-chart cuadros">
                <h3>
                  LOS 11 PROYECTOS Y LAS OBSERVACIONES DETECTADAS POR LA
                  CONTRALORÍA
                </h3>

                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th scope="col">Obra</th>
                      <th scope="col" className="text-right">
                        Presupuesto
                      </th>
                      <th scope="col">Empresa o consorcio ejecutor</th>
                      <th scope="col">Hallazgos identificados</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Mejora de puestos de salud de Abancay y Chacoche</td>
                      <td className="text-right">7 390 513</td>
                      <td>Consorcio Abancay</td>
                      <td>Otorgamiento indebido de adelantos.</td>
                    </tr>
                    <tr>
                      <td>
                        Mejora de Micro Red de Salud Micaela Bastidas (Huanipaca
                        y Tamburco)
                      </td>
                      <td className="text-right">9 774 759</td>
                      <td>Consorcio Micaela Bastidas</td>
                      <td>
                        Documentos del postor no coincidían con los
                        requerimientos de las bases.{" "}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Mejora de planteles iniciales del sector rural de
                        Abancay
                      </td>
                      <td className="text-right">8 351 547</td>
                      <td>C. Ingeniería y Construcción</td>
                      <td>
                        Favorecimiento al consorcio, pese a no acreditar los
                        requisitos.
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Mejora de planteles iniciales del área urbana de Abancay
                      </td>
                      <td className="text-right">9 790 203</td>
                      <td>Consorcio Abancay Avanza</td>
                      <td>
                        Irregularidades en la calificación de la propuesta
                        técnica.
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Mejora del tránsito peatonal y vehicular de tres
                        avenidas en Abancay
                      </td>
                      <td className="text-right">5 683 108 </td>
                      <td>Consorcio Arenas</td>
                      <td>Incremento injustificado del presupuesto.</td>
                    </tr>
                    <tr>
                      <td>
                        Mejora del espacio cultural del Parque Micaela Bastidas
                      </td>
                      <td className="text-right">2 004 900</td>
                      <td>Consorcio Abancay</td>
                      <td>
                        Modificaron las bases para otorgar adelanto
                        injustificado por un millón de soles.
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Rehabilitación de plazas y parques en Abancay, Curahuasi
                        y Tamburco
                      </td>
                      <td className="text-right">9 678 149</td>
                      <td>Consorcio Abancay</td>
                      <td>
                        Modificaron las bases para otorgar adelanto
                        injustificado al contratista.
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Ampliación de servicios de comercialización del mercado
                        Las Américas
                      </td>
                      <td className="text-right">9 621 598</td>
                      <td>Consorcio MYC</td>
                      <td>
                        El consorcio ganador no acreditaba los requerimientos
                        técnicos mínimos.
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Mejora de servicios de comercialización del mercado de
                        Abastos Progreso
                      </td>
                      <td className="text-right">4 163 263</td>
                      <td>Consorcio MYC</td>
                      <td>
                        Otorgan puntaje mayor injustificado al consorcio
                        ganador.
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Ampliación del servicio de energía eléctrica en 12
                        barrios de Abancay
                      </td>
                      <td className="text-right">4 791 332</td>
                      <td>Consorcio San Judas</td>
                      <td>
                        La propuesta tecnica del consorcio consignó
                        documentación falsificada.
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Ampliación del servicio de equipo mecánico del municipio
                        de Curahuasi.
                      </td>
                      <td className="text-right">8 561 068</td>
                      <td>(Ejecución directa)</td>
                      <td>-</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </Fade>

            <Fade delay={80}>
              <p>
                Había entusiasmo. Sin embargo, al culminar la gestión, para
                fines del 2014, el panorama pintaba de color gris.
              </p>
              <p>
                Al año siguiente, 2015, el entonces decano del Colegio de
                Ingenieros de Apurímac, Richard Espinoza Palomino, hizo un
                balance y explicó que, de los 83 proyectos en la región, un 30%
                tenía problemas desde la etapa de licitación y ejecución. A
                estas anomalías se sumaban actos de presunta sobrevaloración y
                “falsificación de planillas y obreros fantasma”, según se dio a
                conocer en el “Foro del Canon Minero” del 2015.
              </p>
              <p>
                En el 2016, se inició una investigación fiscal de oficio. Ya el
                2013 se había advertido que funcionarios de la municipalidad de
                Abancay ejecutaron licitaciones públicas favoreciendo a
                determinados postores. Para tal fin, habían empleado
                requerimientos técnicos o parámetros previamente concertados con
                los postores. Parte de estos hechos fueron consignados en un
                informe policial N° 052-2014-DIRCOPOR-PNP.
              </p>
              <div className="quote bg-grey">
                <em>
                  “Una primera alerta de la Contraloría fue que para la mayoría
                  de los 11 proyectos los postores de la municipalidad eran
                  únicos”
                </em>
              </div>
              <p>
                La Contraloría General de la República tomó partido en los
                hechos y así elaboró la carpeta N° 120-2015-CG. Según el
                detalle, de los 11 proyectos planificados para Abancay, 10 iban
                a ser ejecutados por el municipio provincial y uno por la
                municipalidad distrital de Curahuasi.
              </p>
              <p>
                Una primera alerta de la Contraloría fue que para la mayoría de
                los 11 proyectos los postores eran únicos.
              </p>
              <p>
                El caso entonces llegó al Ministerio Público. El 15 de junio del
                2016 fue emitida la disposición de formalización y continuación
                de una investigación preparatoria en el segundo despacho de la
                fiscalía provincial anticorrupción, a cargo del fiscal Luis
                Arturo Ballón Segovia.
              </p>
              <h2>Empresas de la familia</h2>
              <p>
                Según los avances de la investigación fiscal, existe una red de
                empresas vinculadas con la familia del exalcalde, dedicadas al
                rubro de la construcción civil. Fueron trece empresas detectadas
                como vinculadas con la familia del exalcalde Noe Villavicencio
                Ampuero:
              </p>
              <ol>
                <li>Corporación Villa S.A.C</li>
                <li>MVA Contratistas Generales S.A.C</li>
                <li>Constructora Megasur S.C.R.L.</li>
                <li>Representaciones Verón S.R.L.</li>
                <li>VIMAFER Distribuidores S.R.L.</li>
                <li>Corporación Horizonte.</li>
                <li>Constructora Brisas del Sur.</li>
                <li>Zeta Construcciones S.A.C.</li>
                <li>Andina Asociados S.C.R.L.</li>
                <li>M y L Andina de Inversiones</li>
                <li>Constructora Soldevilla S.R.L.</li>
                <li>Negociaciones y Servicios H Y S S.A.C.</li>
                <li>Grupo H Y S S.R.L.</li>
              </ol>
              <p>
                La investigación además identificó que varias de las empresas
                detalladas anteriormente contrataron con el Estado ya sea de
                forma individual o consorciada, algunas de ellas incluso fueron
                sancionadas por el Organismo Supervisor de Contrataciones con el
                Estado (OSCE) por presentar documentación falsificada.
              </p>
              <h2>INVESTIGACIÓN FISCAL EN CURSO</h2>
              <p>
                La fiscalía determinó formalizar y continuar con la
                investigación preparatoria contra 25 personas por los presuntos
                delitos de asociación ilícita para delinquir, colusión agravada,
                falsificación y uso de documento probado falso.
              </p>

              <div className="container-chart">
                <h3>LISTA DE LOS INVESTIGADOS POR EL MINISTERIO PÚBLICO</h3>
                <div className="d-flex flex-wrap justify-content-center align-items-center grid-abancay">
                  <div
                    className="list-item d-flex flex-column justify-content-center"
                    style={{ backgroundColor: "#E7B109" }}
                  >
                    Ana Luz Chacón Ponce <small>DNI 43422619</small>
                  </div>
                  <div
                    className="list-item d-flex flex-column justify-content-center"
                    style={{ backgroundColor: "#E7B311" }}
                  >
                    Carlos Alberto Gamarra Urtecho <small>DNI 10626796</small>
                  </div>
                  <div
                    className="list-item d-flex flex-column justify-content-center"
                    style={{ backgroundColor: "#E8B619" }}
                  >
                    Celinda Ernestina Huarancca Cucho{" "}
                    <small>DNI 09257746</small>
                  </div>
                  <div
                    className="list-item d-flex flex-column justify-content-center"
                    style={{ backgroundColor: "#E9B922" }}
                  >
                    César Tucta Miranda <small>DNI 22314054</small>
                  </div>
                  <div
                    className="list-item d-flex flex-column justify-content-center"
                    style={{ backgroundColor: "#EABB2A" }}
                  >
                    Crisanto Serafín Noriega Vizcarra{" "}
                    <small>DNI 31676242</small>
                  </div>
                  <div
                    className="list-item d-flex flex-column justify-content-center"
                    style={{ backgroundColor: "#EBBE33" }}
                  >
                    Daniel Omar Tapie López <small>DNI 10610045</small>
                  </div>
                  <div
                    className="list-item d-flex flex-column justify-content-center"
                    style={{ backgroundColor: "#EBC13B" }}
                  >
                    Eddyson Felipe Mendoza Humpiri <small>DNI 44159679</small>
                  </div>
                  <div
                    className="list-item d-flex flex-column justify-content-center"
                    style={{ backgroundColor: "#ECC344" }}
                  >
                    Edison Huamanñahui Cruz <small>DNI 41889911</small>
                  </div>
                  <div
                    className="list-item d-flex flex-column justify-content-center"
                    style={{ backgroundColor: "#EDC64C" }}
                  >
                    Edward Stanlin Meza Villarreal <small>DNI 44336943</small>
                  </div>
                  <div
                    className="list-item d-flex flex-column justify-content-center"
                    style={{ backgroundColor: "#EEC955" }}
                  >
                    Efraín Puma Condori <small>DNI 40940315</small>
                  </div>
                  <div
                    className="list-item d-flex flex-column justify-content-center"
                    style={{ backgroundColor: "#EFCB5D" }}
                  >
                    Eleuterio Leonidas Soria Álvarez <small>DNI 31005012</small>
                  </div>
                  <div
                    className="list-item d-flex flex-column justify-content-center"
                    style={{ backgroundColor: "#F0CE66" }}
                  >
                    Elizabeth Cruz Borda <small>DNI 41730819</small>
                  </div>
                  <div
                    className="list-item d-flex flex-column justify-content-center"
                    style={{ backgroundColor: "#F0D16E" }}
                  >
                    Elizabeth Huanca Juárez <small>DNI 42458363</small>
                  </div>
                  <div
                    className="list-item d-flex flex-column justify-content-center"
                    style={{ backgroundColor: "#F1D377" }}
                  >
                    Fany Contreras Concha <small>DNI 40221024</small>
                  </div>
                  <div
                    className="list-item d-flex flex-column justify-content-center"
                    style={{ backgroundColor: "#F2D67F" }}
                  >
                    Gustavo Cristhian Vargas Reynoso <small>DNI 45211556</small>
                  </div>
                  <div
                    className="list-item d-flex flex-column justify-content-center"
                    style={{ backgroundColor: "#F3D988" }}
                  >
                    Isaac Chirinos Camero <small>DNI 46603546</small>
                  </div>
                  <div
                    className="list-item d-flex flex-column justify-content-center"
                    style={{ backgroundColor: "#F4DC90" }}
                  >
                    Jorge Adrián Huanqui Pérez <small>DNI 02364142</small>
                  </div>
                  <div
                    className="list-item d-flex flex-column justify-content-center"
                    style={{ backgroundColor: "#F5DE99" }}
                  >
                    Jorge Antonio Noriega Cortez <small>DNI 44927003</small>
                  </div>
                  <div
                    className="list-item d-flex flex-column justify-content-center"
                    style={{ backgroundColor: "#F5E1A1" }}
                  >
                    José Morgan Córdova <small>DNI 06704912</small>
                  </div>
                  <div
                    className="list-item d-flex flex-column justify-content-center"
                    style={{ backgroundColor: "#F6E4AA" }}
                  >
                    Juan Ángel Robles Garro <small>DNI 31677692</small>
                  </div>
                  <div
                    className="list-item d-flex flex-column justify-content-center"
                    style={{ backgroundColor: "#F7E6B2" }}
                  >
                    Lyndon Glicerio Gonzales Gianino <small>DNI 07721944</small>
                  </div>
                  <div
                    className="list-item d-flex flex-column justify-content-center"
                    style={{ backgroundColor: "#F8E9BB" }}
                  >
                    Martha Batallanos Enciso <small>DNI 31012222</small>
                  </div>
                  <div
                    className="list-item d-flex flex-column justify-content-center"
                    style={{ backgroundColor: "#F9ECC3" }}
                  >
                    Marco Pumacayo Vera <small>DNI 41806512</small>
                  </div>
                  <div
                    className="list-item d-flex flex-column justify-content-center"
                    style={{ backgroundColor: "#FAEECC" }}
                  >
                    Noe Villavicencio Ampuero <small>DNI 40373447</small>
                  </div>
                  <div
                    className="list-item d-flex flex-column justify-content-center"
                    style={{ backgroundColor: "#FAF1D4" }}
                  >
                    Zenón Villavicencio Ampuero <small>DNI 31036916</small>
                  </div>
                </div>
              </div>

              <p>
                El 24 de noviembre del 2017, el Ministerio Público solicitó
                prisión preventiva contra Noé Villavicencio Ampuero, Zenón
                Villavicencio Ampuero (hermano del alcalde), Carlos Alberto
                Gamarra Urtecho (gerente de acondicionamiento territorial y
                desarrollo urbano), Edisson Huamanñahui Cruz (subgerente de
                supervisión y liquidación de obras) y Martha Batallanos Enciso
                (miembro del comité especial).{" "}
              </p>
            </Fade>

            <div className="img-container">
              <img
                className="img-fluid full-width"
                src={Foto1}
                alt="El excalde de Abancay Noé Villavicencio cumplió prisión preventiva"
              />
              <div className="img-legend">
                El excalde de Abancay Noé Villavicencio cumplió prisión
                preventiva
              </div>
            </div>

            <Fade delay={80}>
              <p>
                Sobre la marcha, el fiscal Arturo Ballón Segovia abandonó la
                investigación. El caso pasó por manos de los fiscales Edison
                Quispe Huanca y Hernán Warthon Quintanilla, quienes no
                evidenciaron mayores avances en las pesquisas.
              </p>
              <p>
                Este año, Ballón Segovia volvió a asumir la investigación y
                declaró el caso como complejo.
              </p>
              <p>
                Por su parte, el exalcalde Noe Villavicencio había cumplido doce
                meses de prisión preventiva y la medida fue ampliada por un
                plazo similar, pero ante el exceso de carcelería, el investigado
                salió bajo la figura de libertad condicional.{" "}
              </p>
              <p>
                Zenón Villavicencio Ampuero, su hermano, en la actualidad se
                encuentra prófugo.
              </p>

              <h2>Millonaria deuda</h2>
              <p>
                Un daño colateral tiene que ver con la deuda y los intereses por
                el crédito que gestionó Noe Villavicencio.
              </p>
              <p>
                La gestión siguiente (2015-2018), a cargo del alcalde Manuel
                Campos Céspedes, decidió no asumir ningún pago. Durante los
                cuatro años de su gestión, no pagaron ni un sol de los intereses
                que ya se iban generando.{" "}
              </p>
              <p>
                Luego, en el 2019, inició la gestión del alcalde actual, Guido
                Chahuaylla Maldonado, quien ya dijo que tampoco pagará lo
                ocasionado por el mal llamado “adelanto del canon”.
              </p>
              <div className="quote bg-grey">
                <em>
                  “Según la Sub Gerencia de Presupuesto de la municipalidad de
                  Abancay, al 2020, la deuda asciende a 119 millones de soles”
                </em>
              </div>

              <p>
                En documentación proporcionada para esta investigación se
                establece que la comuna tenía que pagar 8 millones de soles al
                año. Como no hubo intención de respuesta sobre el préstamo, en
                enero de este año fueron bloqueadas todas las cuentas del
                municipio. Fue necesaria una gestión en Lima para destrabar esta
                decisión del MEF, para continuar con las obras.
              </p>
              <p>
                Según la Sub Gerencia de Presupuesto de la Municipalidad
                Provincial de Abancay, al 2020, el monto de la deuda asciende a
                119 millones de soles. El crédito inicial fue de 79 millones de
                soles. Hasta el momento hay un incremento por 40 millones de
                soles y, por los intereses, la deuda seguirá creciendo.
              </p>
              <p>
                Hasta el momento el municipio y el gobierno central no llegan a
                una salida para resolver esta deuda. El actual alcalde
                Chahuaylla ha planteado la reprogramación del cronograma de
                pagos a partir del 2028.
              </p>
              <p>
                En paralelo, el municipio ahora intenta acceder a un nuevo
                crédito. El mal llamado “adelanto de canon”, ahora ha sido
                reemplazado por un sistema conocido como “facilidad financiera”.
                El 31 de julio de 2020, la Municipalidad Provincial de Abancay
                solicitó el otorgamiento de la “facilidad financiera” por 94
                millones de soles, a cuenta futura del canon minero. La única
                diferencia es que ahora el crédito estaría libre de intereses.
                Aún no hay respuesta a la solicitud.{" "}
              </p>
              <h2>Las obras</h2>
              <p>
                De las once obras ejecutadas con el anterior préstamo, la
                mayoría están inconclusas. Por estar en investigación, la actual
                gestión no puede hacer nada, ni el mantenimiento.{" "}
              </p>
              <div className="img-container">
                <img
                  className="img-fluid full-width"
                  src={Foto2}
                  alt="Mercado Las Américas, hubo retraso para que entre en funcionamiento."
                />
                <div className="img-legend">
                  Mercado Las Américas, hubo retraso para que entre en
                  funcionamiento.
                </div>
              </div>
              <p>
                Un ejemplo: el proyecto “Mejoramiento y ampliación de los
                servicios de comercialización del mercado de abastos Las
                Américas”, a cargo del consorcio M y C, presenta deficiencias en
                el proceso constructivo, según el informe de la Contraloría N°
                478-2014-CG/L485. Recién en el 2016, se levantaron las
                observaciones para que entre en funcionamiento.
              </p>
              <p>
                Otra obra que tuvo observaciones es el “Mejoramiento del
                servicio del espacio cultural y de esparcimiento del parque
                Micaela Bastidas”, a cargo de la empresa 3G Constructora SAC.,
                que fue integrante del Consorcio Abancay.
              </p>

              <div className="img-container">
                <img
                  className="img-fluid"
                  src={Foto3}
                  alt="El parque Micaela Bastidas con las piletas que no están en funcionamientos."
                />
                <div className="img-legend">
                  El parque Micaela Bastidas con las piletas que no están en
                  funcionamientos.
                </div>
              </div>

              <p>
                La municipalidad de Abancay recién accederá a recursos por canon
                minero a partir del 2022. De momento, los créditos otorgados
                para cubrir este vacío presupuestal ya han sacado a luz
                deficiencias en ejecución y serias sospechas de corrupción. Eso,
                además de una millonaria deuda.
              </p>
            </Fade>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default NotaApurimac;
